import { useState, useEffect, memo } from "react"
import playSvg from "img/player/play_arrow.svg"
import playSecondarySvg from "img/player/play_arrow_secondary.svg"
import restartSvg from "img/player/play_restart.svg"
import restartWhiteSvg from "img/player/play_restart_white.svg"
import deleteSvg from "img/player/delete.svg"
import deleteWhiteSvg from "img/player/delete_white.svg"
import cancelSvg from "img/player/cancel.svg"
import cancelWhiteSvg from "img/player/cancel_white.svg"
import ffAd_icon from "img/player/ffAd_icon.svg"
import moreSvg from "img/player/more.svg"
import infoSvg from "img/player/info.svg"
import recordSeriesSvg from "img/player/record_series.svg"
import visibilitySvg from "img/player/visibility.svg"
import archiveSvg from "img/player/archive.svg"
import personSvg from "img/player/person_switch_profile.svg"
import infoFilledSvg from "img/player/info_filled.svg"
import { rootStore } from "store/RootStore"
import { moment } from "store/util/moment"
import { bookmarkPercentage, eventPercentage } from "utils/EventHelpers"


import "./ButtonComponents.css"

const widthBreak = 540
const dialogButtonWidthNormal = 328


// MTVW-811
/*
const getVariant = (bId) => {
	//return computed(() => {
	let variant = "secondary"
	const buttonRect = document.getElementById(bId)?.getBoundingClientRect() ?? null
	//const containerRect = document.getElementById("recordInfoContainer")?.getBoundingClientRect() ?? null
	const containerRect = document.getElementById(bId)?.parentElement?.getBoundingClientRect() ?? null
	// why are all values of the rects sometimes all 0 in the mobile view???
	if (containerRect && buttonRect) variant = containerRect.width > 0 && Math.abs(containerRect.x - buttonRect.x) < 10 && Math.abs(containerRect.y - buttonRect.y) < 10 ? "primary" : "secondary"
	//console.debug("boundingRects= %s, %s, cRect %o, bRect %o", bId, variant, containerRect, buttonRect)
	return variant
	//}).get()
}
*/

export const ButtonPlay = memo((({ variant, bId, label, onClick, dataTest }) => {
	// TODO: do we need variant?
	return (
		<div id={bId} className="buttonBody colorRed" onClick={onClick} data-test={dataTest}>
			<div className="buttonIconContainer">
				<img className="buttonSvg" style={{
					/*borderRadius: 8, overflow: 'hidden', justifyContent: 'flex-start', alignItems: 'center', gap: 1, display: 'inline-flex'*/
				}} src={playSvg}></img>
			</div>
			<div className="buttonLabel labelWhite">{label}</div>
		</div>)
}))

export const ButtonLive = memo((({ variant, bId, label, onClick, dataTest, event }) => {
	// variant is not needed, is always primary
	const getProgress = () => {
		return eventPercentage(event)
	}
	//console.debug("ButtonLive=", event, getProgress())
	return (
		<div id={bId} className="buttonBody colorRed" onClick={onClick} data-test={dataTest} style={{ paddingLeft: "unset", paddingRight: "unset" /*, justifyContent: "center"*/ }}>
			<div className="liveFrame1">
				<div className="liveFrame2">
					<div className="buttonIconContainer">
						<div className="liveEllipse" />
					</div>
					<div className="buttonLabel labelWhite">{label?.toUpperCase()}</div>
				</div>
				<div className="liveProgressBarContainer">
					<div className="liveProgressBackground" />
					<div className="liveProgress" style={{ width: getProgress() + "%" }} />
				</div>
			</div>
		</div>
	)
}))

/*
<div className="PlayButton" style={{width: 140, height: 56, background: '#D40037', borderRadius: 8, justifyContent: 'center', alignItems: 'center', gap: 1, display: 'inline-flex'}}>
  <div className="Frame127" style={{paddingTop: 13, paddingBottom: 4, paddingLeft: 4, paddingRight: 4, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 5, display: 'inline-flex'}}>
	 <div className="Frame1" style={{alignSelf: 'stretch', paddingLeft: 32, paddingRight: 24, justifyContent: 'center', alignItems: 'center', gap: 4, display: 'inline-flex'}}>
		<div className="Icon" style={{width: 24, height: 24, position: 'relative'}}>
		  <div className="Ellipse4" style={{width: 16, height: 16, left: 4, top: 4, position: 'absolute', background: '#FFC107', borderRadius: 9999}} />
		</div>
		<div className="Label" style={{color: '#F3F3F3', fontSize: 24, fontFamily: 'Europa-Bold', fontWeight: '700', wordWrap: 'break-word'}}>LIVE</div>
	 </div>
	 <div className="ProgressBar" style={{width: 132, height: 4, position: 'relative'}}>
		<div className="Background" style={{width: 132, height: 4, left: 0, top: 0, position: 'absolute', background: 'rgba(255, 255, 255, 0.30)', borderRadius: 2}} />
		<div className="Progress" style={{width: 49.50, height: 4, left: 0, top: 0, position: 'absolute', background: '#F3F3F3', borderRadius: 2}} />
	 </div>
  </div>
</div>
*/
export const ButtonRestart = memo((({ variant, bId, label, onClick, dataTest }) => {
	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	const svg = variant === "primary" ? restartWhiteSvg : restartSvg

	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} onClick={onClick} data-test={dataTest}>
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={svg}></img>
			</div>
			<div className={`buttonLabel ${labelColorClass}`}>{label}</div>
		</div>
	)
}))

export const ButtonRecord = memo((({ variant, bId, label, onClick, dataTest }) => {
	/*
	const [variant, setVariant] = React.useState("secondary")
	React.useEffect(() => {
		setVariant(getVariant(bId))
	}, [document.getElementById(bId)?.parentElement?.getBoundingClientRect()])
	*/

	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	const shapeStyle = variant === "primary" ?
		{ width: 16, height: 16, left: 3, top: 4, position: 'absolute', background: '#C91010', borderRadius: 9999, border: '1.60px white solid' } :
		{ width: 20, height: 20, left: 2, top: 2, position: 'absolute', background: '#C91010', borderRadius: 9999, border: '2px white solid' }

	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} style={{ gap: 4 }} onClick={onClick} data-test={dataTest}>
			<div className="buttonIconContainer" >
				<div className="Shape" style={shapeStyle} />
			</div>
			<div className={`buttonLabel ${labelColorClass}`}>{label}</div>
		</div>)
}))

export const ButtonDelete = memo((({ variant, bId, label, onClick, dataTest, inModal = false, width }) => {
	/*
	const [variant, setVariant] = React.useState("secondary")
	React.useEffect(() => {
		setVariant(getVariant(bId))
	}, [document.getElementById(bId)?.parentElement?.getBoundingClientRect()])
	*/

	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	const svg = variant === "primary" ? deleteWhiteSvg : deleteSvg
	const shapeStyle = variant === "primary" ?
		{ width: 16, height: 16, left: 3, top: 4, position: 'absolute', /*background: '#C91010', borderRadius: 9999, border: '1.60px white solid'*/ } :
		{ width: 20, height: 20, left: 2, top: 2, position: 'absolute', /*background: '#C91010', borderRadius: 9999, border: '2px white solid'*/ }
	const bodyStyle = inModal ? { width: width, height: 40, paddingLeft: 16, paddingRight: 16/*, justifyContent: "center"*/ } : {}
	const labelStyle = inModal ? { fontSize: 18, paddingLeft: 5, lineHeight: 0.9 } : {}
	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} style={bodyStyle} onClick={onClick} data-test={dataTest}>
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={svg} style={shapeStyle} ></img>
			</div>
			<div className={`buttonLabel ${labelColorClass}`} style={labelStyle}>{label}</div>
		</div>
	)
}))

export const ButtonCancel = memo((({ variant, bId, label, onClick, dataTest, inModal = false, width }) => {
	/*
	const [variant, setVariant] = React.useState("secondary")
	React.useEffect(() => {
		setVariant(getVariant(bId))
	}, [document.getElementById(bId)?.parentElement?.getBoundingClientRect()])
	*/
	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	const svg = variant === "primary" ? cancelWhiteSvg : cancelSvg
	const shapeStyle = variant === "primary" ?
		{ width: 20, height: 20, left: 2, top: 2, position: 'absolute', /*background: '#F3F3F3', borderRadius: 9999, border: '1.60px white solid'*/ } :
		{ width: 20, height: 20, left: 2, top: 2, position: 'absolute', /*background: '#C91010', borderRadius: 9999, border: '2px white solid'*/ }
	const bodyStyle = inModal ? { width: width, height: 40, paddingLeft: 16, paddingRight: 16/*, justifyContent: "center"*/ } : {}
	const labelStyle = inModal ? { fontSize: 18, paddingLeft: 5, lineHeight: 0.9 } : {}
	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} style={bodyStyle} onClick={onClick} data-test={dataTest}>
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={svg} style={shapeStyle} ></img>
			</div>
			<div className={`buttonLabel ${labelColorClass}`} style={labelStyle}>{label}</div>
		</div>
	)
}))

export const ButtonPremium = memo((({ bId, label, onClick, dataTest }) => {
	// MTVW-849: comment backdropFilter, caused black screen on Chrome/macOS
	return (
		<div id={bId} className="buttonBody colorDark" onClick={onClick} data-test={dataTest}
			style={{ /*width: 241,*/ paddingLeft: 16, paddingRight: 16, paddingTop: 13, paddingBottom: 13, /*background: 'rgba(255, 255, 255, 0.10)',*/ borderRadius: 99999, overflow: 'hidden', border: '1px rgba(255, 255, 255, 0.30) solid', /*backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)', mozbackdropFilter: 'blur(4px)',*/ justifyContent: 'flex-start', alignItems: 'center', gap: 4, display: 'inline-flex' }}>
			{/*<div className="Icon" style={{ width: 24, height: 24, position: 'relative' }}>
				<div className="BoundingBox" style={{ width: 24, height: 24, left: 0, top: 0, position: 'absolute', background: '#D9D9D9' }} />*/}
			<div className="buttonIconContainer" > {/* style={{ width: 20, height: 20, left: 2, top: 2, position: 'absolute' }} */}
				<img className="buttonSvg" src={ffAd_icon} ></img> {/* style={{ width: 20, height: 20, left: 0, top: 0, position: 'absolute', background: '#F3F3F3' }} */}
			</div>
			{/*</div>*/}
			<div className="buttonLabel labelWhite" >{label}</div>
		</div>
	)
}))

export const ButtonResume = memo((({ variant, bId, label, onClick, event, bookmark }) => {
	const getProgress = () => {
		return bookmarkPercentage(bookmark, event)
	}

	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	const svg = variant === "primary" ? playSvg : playSecondarySvg
	const liveProgressBackground = variant === "primary" ? "liveProgressBackground" : "liveProgressBackgroundSecondary"
	const liveProgress = variant === "primary" ? "liveProgress" : "liveProgressSecondary"
	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} onClick={onClick} style={{ paddingLeft: "unset", paddingRight: "unset" /*, justifyContent: "center"*/ }}>
			<div className="liveFrame1">
				<div className="liveFrame2">
					<div className="buttonIconContainer">
						<img className="buttonSvg" style={{
							/*borderRadius: 8, overflow: 'hidden', justifyContent: 'flex-start', alignItems: 'center', gap: 1, display: 'inline-flex'*/
						}} src={svg}></img>
					</div>
					<div className={`buttonLabel ${labelColorClass}`}>{label}</div>
				</div>
				<div className="liveProgressBarContainer">
					<div className={liveProgressBackground} />
					<div className={liveProgress} style={{ width: getProgress() + "%" }} />
				</div>
			</div>
		</div>
	)
}))

export const ButtonRecordSeries = memo((({ bId, label, onClick, dataTest, inModal = false, width }) => {
	return (
		<div id={bId} className="buttonBody colorWhite" style={{ width: width, height: 40, paddingLeft: 16, paddingRight: 16 }} onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={recordSeriesSvg}></img>
			</div>
			<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 5 }}>{label}</div>
		</div>)
}))

export const ButtonVisibility = memo((({ bId, label, onClick, dataTest, inModal = false, width }) => {
	return (
		<div id={bId} className="buttonBody colorWhite" style={{ width: width, height: 40, paddingLeft: 16, paddingRight: 16 }} onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={visibilitySvg}></img>
			</div>
			<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 5, lineHeight: 0.9 }}>{label}</div>
		</div>)
}))

export const ButtonArchive = memo((({ bId, label, onClick, dataTest, inModal = false, width }) => {
	console.debug("ButtonArchive", width)
	return (
		<div id={bId} className="buttonBody colorWhite" style={{ width: width, height: 40, paddingLeft: 16, paddingRight: 16 }} onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={archiveSvg}></img>
			</div>
			<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 5 }}>{label}</div>
		</div>)
}))

export const ButtonSwitchProfile = memo((({ bId, label, onClick, dataTest, inModal = false, width }) => {
	return (
		<div id={bId} className="buttonBody colorWhite" style={{ width: width, height: 40, paddingLeft: 16, paddingRight: 16 }} onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" src={personSvg}></img>
			</div>
			<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 5 }}>{label}</div>
		</div>)
}))


export const ButtonGeneric = memo(({ variant, bId, label, onClick, dataTest, inModal = false, width }) => {
	console.debug("ButtonGeneric", width)
	const bodyColorClass = variant === "primary" ? "colorRed" : "colorWhite"
	const labelColorClass = variant === "primary" ? "labelWhite" : "labelBlack"
	return (
		<div id={bId} className={`buttonBody ${bodyColorClass}`} style={{ width: width ?? dialogButtonWidthNormal, height: 40, paddingLeft: 16, paddingRight: 16, justifyContent: "center" }}
				data-test={dataTest}
				/* USEFUL to see fired events
				onTouchStart={() => console.debug('clickOn 1. Touch Start')}
				onTouchEnd={() => console.debug('clickOn 2. Touch End')}
				onMouseDown={() => console.debug('clickOn 3. Mouse Down')}
				onMouseUp={() => console.debug('clickOn 4. Mouse Up')}
				onClick={() => console.debug('clickOn 5. Click')}
				onPointerUp={() => console.debug('onPointerUp 6. onPointerUp')}
				*/
				onClick={(e) => {
					onClick(e)
				}}
		>
			<div className={`buttonLabel ${labelColorClass}`} style={{ fontSize: 18, paddingLeft: 5 }}>{label}</div>
		</div>)
})

export const ButtonMore = memo((({ bId, onClick, label, dataTest }) => {
	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])
	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}

	const style = {
		width: innerWidth <= widthBreak ? "" : 56, paddingLeft: innerWidth <= widthBreak ? 14 : "unset",
		paddingRight: "unset",
		justifyContent: innerWidth <= widthBreak ? "" : "center"
	}
	return (
		<div id={bId} className="buttonBody colorWhite"
			style={style}
			onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" style={{ width: 32, height: 32 }} src={moreSvg}></img>
			</div>
			{innerWidth <= widthBreak ?
				<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 4 }}>{label}</div>
				: <></>
			}
		</div>)
}))

export const ButtonInfo = memo((({ bId, onClick, label, dataTest }) => {
	const [innerWidth, setInnerWidth] = useState(window.innerWidth)
	useEffect(() => {
		window.addEventListener("resize", handleResize)
		return () => {
			window.removeEventListener("resize", handleResize)
		}
	}, [])
	const handleResize = () => {
		setInnerWidth(window.innerWidth)
	}
	const style = {
		width: innerWidth <= widthBreak ? "" : 56, paddingLeft: innerWidth <= widthBreak ? 14 : "unset",
		paddingRight: "unset",
		justifyContent: innerWidth <= widthBreak ? "" : "center"
	}
	return (
		<div id={bId} className="buttonBody colorWhite"
			style={style} onClick={onClick} data-test={dataTest} >
			<div className="buttonIconContainer">
				<img className="buttonSvg" style={{ width: 24, height: 24 }} src={infoSvg}></img>
			</div>
			{innerWidth <= widthBreak ?
				<div className="buttonLabel labelBlack" style={{ fontSize: 18, paddingLeft: 4 }}>{label}</div>
				: <></>
			}
		</div>)
}))

export const Switch = memo((({ bId, onState, label, onClick, dataTest }) => {
	//console.debug("label=", label)
	return (
		<>
			{label}
			{onState === true ?
				<div className="SwitchOn"
					onClick={onClick} data-test={dataTest}>
					<div className="HandleOn">
						<div className="TargetOn">
							<div className="StateOn">
								<div className="ShapeOn">
									<div className="ContainerOn" />
								</div>
							</div>
						</div>
					</div>
				</div>
				: <div className="SwitchOff"
					onClick={onClick} data-test={dataTest}>
					<div className="HandleOff">
						<div className="TargetOff">
							<div className="StateOff">
								<div className="ShapeOff">
									<div className="ContainerOff" />
								</div>
							</div>
						</div>
					</div>
				</div>
			}
		</>
	)
}))

export const InfoPanel = memo((({ bId, label, buttonLabel = null, onClick, dataTest }) => {
	return (
		<div id={bId} className="InfoPanelContainer" data-test={dataTest} style={{ height: "auto" /*buttonLabel ? 108 : 60*/ }}>
			<div className="InfoPanel" style={{ height: "auto" }}>
				<div className="InfoPanelIconFrame">
					<img className="buttonSvg" style={{ width: 32, height: 32 }} src={infoFilledSvg}></img>
				</div>
				{/* content frame now stacks vertically */}
            <div className="InfoPanelContentFrame">
					<div className="InfoPanelTextFrame">
						{/* dangerouslySetInnerHTML required for infopanelChannelNotSubscribed */}
						<div className="InfoPanelText" dangerouslySetInnerHTML={{ __html: label }}></div>
					</div>
					<div className="InfoPanelButtonFrame">
						{buttonLabel &&
							<div className="InfoPanelButton" onClick={onClick}>
								<div className="InfoPanelButtonText">{buttonLabel}</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}))
